import { createApp } from "vue";
import App from "./App.vue";
import store from "./store";
import { library } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { fas } from "@fortawesome/free-solid-svg-icons";
import { far } from "@fortawesome/free-regular-svg-icons";
import { ColorPicker } from "vue-accessible-color-picker";
import { BootstrapIconsPlugin } from "bootstrap-icons-vue";
import axios from "axios";
import VueAxios from "vue-axios";
import router from "./router";
import { messages } from "./assets/messages";
import { InlineSvgPlugin } from "vue-inline-svg";

library.add(fas, far);
import { createI18n } from "vue-i18n";

const i18n = createI18n({
  legacy: false,
  locale: "de",
  fallBackLocale: "en",
  messages,
});

createApp(App)
  .use(store)
  .use(BootstrapIconsPlugin)
  .use(VueAxios, axios)
  .use(router)
  .use(i18n)
  .use(InlineSvgPlugin)
  .component("font-awesome-icon", FontAwesomeIcon)
  .component("ColorPicker", ColorPicker)
  .mount("#app");
